export const HOVER_MENUS = {
    WISHLIST: 'Wishlist',
    SELL: 'Selling',
    BUY: 'Buying',
    LOCALIZATION: 'Localization',
    CURRENCY: 'Currency',
    HOW_TRADERA_WORKS: 'HowTraderaWorks'
} as const;
